import { render, staticRenderFns } from "./sidebar_item_epic.vue?vue&type=template&id=a9c46c4c&"
import script from "./sidebar_item_epic.vue?vue&type=script&lang=js&"
export * from "./sidebar_item_epic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sidebar_item_epic.vue"
export default component.exports